import { connect } from "react-redux";
import { getWorkSpaces } from "Areas/Sidebar/WorkSpaces";
import TaskStatistics from "./taskStatistics";
import actionCreators from "./redux/actionCreators";
import { getOverallStatistics, getInProgress, getTaskStatistics, getSourceStatistics } from "./redux/selectors";
import getScope from "./utils/getScope";
const mapStateToProps = (state, ownProps) => ({
    overallStatistics: getOverallStatistics(getScope(ownProps.projectId, ownProps.workSpaceId), state),
    workSpaces: getWorkSpaces(state),
    inProgress: getInProgress(getScope(ownProps.projectId, ownProps.workSpaceId), state),
    taskStatistics: getTaskStatistics(getScope(ownProps.projectId, ownProps.workSpaceId), state),
    sourceStatistics: getSourceStatistics(getScope(ownProps.projectId, ownProps.workSpaceId), state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (scope, params) => {
        dispatch(actionCreators.getTaskStatistics(scope, params));
        params && dispatch(actionCreators.setTaskStatisticsFilterParams(scope, params));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(TaskStatistics);
